import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withHooks, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { exhaustMap, pipe } from 'rxjs';

import { LanguagesApiService } from '../../services';
import { LanguagesState } from './languages.interface';

const INITIAL_STATE: LanguagesState = {
  languages: [],
  languageConfigs: [],
};

export const LanguagesStore = signalStore(
  {
    providedIn: 'root',
  },
  withState(INITIAL_STATE),
  withMethods((store, languagesApiService = inject(LanguagesApiService)) => ({
    getLanguages: rxMethod<void>(
      pipe(
        exhaustMap(() =>
          languagesApiService.getLanguages().pipe(
            tapResponse({
              next: (languages) =>
                patchState(store, {
                  languages: languages.payload.map((language) => language.code),
                  languageConfigs: languages.payload,
                }),
              error: console.error,
            }),
          ),
        ),
      ),
    ),
  })),
  withHooks({
    onInit: (store) => store.getLanguages(),
  }),
);
